import { CETheme } from './theme.types';
import { ThemeNames } from 'utils/constants/hostConfig.constants';
import careexpandTheme from './careExpandTheme.constant';
import mcsTheme from './mcsTheme.constant';

type ThemeList = { [key in ThemeNames]: CETheme };
const appThemes: ThemeList = { baseTheme: careexpandTheme, mcsTheme };

export default appThemes;
